import React, { useState } from 'react';
import { auth, db } from '../../config/firebase';
import {
  signInWithEmailAndPassword,
  sendPasswordResetEmail
} from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { useNavigate, useLocation } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { useAuth } from '../../context/AuthContext';
import logo from '../../logo.png';
import { APP_VERSION } from '../../version';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [resetSent, setResetSent] = useState(false);
  const [showReset, setShowReset] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser, userRole } = useAuth();

  // Mtu anaweza kufika hapa akiwa TAYARI ameingia — mfano akitaka
  // kubadili akaunti. Hatumrudishi popote; tunamwonyesha hali yake
  // na kumpa chaguo mbili wazi.
  const signedIn = !!currentUser;

  const roleLabel =
    userRole === 'admin' ? 'Admin' :
    userRole === 'staff' ? 'Staff' :
    userRole === 'donor' ? 'Donor' :
    'nafasi haijulikani';

  function goToMyPage() {
    if (userRole === 'admin') navigate('/admin', { replace: true });
    else if (userRole === 'staff') navigate('/staff', { replace: true });
    else if (userRole === 'donor') navigate('/donor', { replace: true });
    else setError('Nafasi ya akaunti hii haijulikani. Ondoka kisha ingia kwa akaunti nyingine.');
  }

  async function forceSignOut() {
    try { await signOut(auth); } catch (err) { console.error(err); }
    setError('');
    setEmail('');
    setPassword('');
  }

  async function handleLogin(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const result = await signInWithEmailAndPassword(
        auth, email, password
      );

  // Allow login regardless of email verification

      const docRef = doc(db, 'users', result.user.uid);
      const docSnap = await getDoc(docRef);

 if (docSnap.exists()) {
        const userRole = docSnap.data().role;
        // Navigate based on actual role — ignore pill selection
        // Kama alikuwa akienda mahali fulani kabla, mrudishe hapo
        const from = location.state?.from;
        if (userRole === 'admin') navigate(from || '/admin', { replace: true });
        else if (userRole === 'staff') navigate(from || '/staff', { replace: true });
        else if (userRole === 'donor') navigate(from || '/donor', { replace: true });
        else setError('Nafasi ya akaunti hii haijulikani. Wasiliana na admin.');
      } else {
        // Try to create user document if missing
        setError(
          'Akaunti hii haijakamilika kwenye mfumo. Wasiliana na admin.'
        );
      }
    } catch (err) {
      if (err.code === 'auth/user-not-found') {
        setError('No account found with this email.');
      } else if (err.code === 'auth/wrong-password') {
        setError('Wrong password. Please try again.');
      } else {
        setError('Wrong email or password. Please try again.');
      }
    }
    setLoading(false);
  }

  async function handleReset(e) {
    e.preventDefault();
    setError('');
    try {
      await sendPasswordResetEmail(auth, resetEmail);
      setResetSent(true);
    } catch (err) {
      setError('Email not found. Please check and try again.');
    }
  }

  return (
    <div style={styles.page}>
      <div style={styles.orb}></div>
      <div style={styles.card}>

        {/* LOGO */}
        <div style={styles.logoRow}>
          <div style={styles.logoMark}>
            <img
              src={logo}
              alt="Iyanna Foundation"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }}
            />
          </div>
          <div>
            <div style={styles.logoName}>
              Iyanna Foundation
            </div>
            <div style={styles.logoSub}>
              PROTECT & EDUCATE
            </div>
          </div>
        </div>

        <div style={styles.heading}>Admin / Staff Portal</div>
        <div style={styles.sub}>
          Sign in to your organization account
        </div>

        {/* FORM */}
        <form onSubmit={handleLogin}>
          <div style={styles.label}>Email Address</div>
          <input
            style={styles.input}
            type="email"
            placeholder="you@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <div style={styles.label}>Password</div>
          <div style={styles.passwordRow}>
            <input
              style={styles.passwordInput}
              type={showPassword ? 'text' : 'password'}
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              style={styles.eyeBtn}
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword
                ? <AiOutlineEyeInvisible
                    size={20}
                    color="rgba(255,255,255,0.6)"
                  />
                : <AiOutlineEye
                    size={20}
                    color="rgba(255,255,255,0.6)"
                  />
              }
            </button>
          </div>
          {error && <div style={styles.error}>{error}</div>}

          {signedIn && (
            <div style={{
              background: '#EFF6FF', border: '1px solid #BFDBFE', color: '#1E3A8A',
              padding: '14px 16px', borderRadius: '11px', fontSize: '13px',
              lineHeight: 1.7, marginBottom: '16px',
            }}>
              Tayari umeingia kama <strong>{currentUser.email}</strong> ({roleLabel}).
              {!userRole && ' Nafasi ya akaunti hii haijulikani, ndio maana huwezi kufika popote.'}
              <div style={{ display: 'flex', gap: '8px', marginTop: '12px', flexWrap: 'wrap' }}>
                {userRole && (
                  <button
                    type="button"
                    onClick={goToMyPage}
                    style={{
                      background: '#1D4ED8', color: '#fff', border: 'none',
                      padding: '10px 16px', borderRadius: '9px', fontSize: '12.5px',
                      fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit',
                    }}
                  >
                    Endelea kama {roleLabel}
                  </button>
                )}
                <button
                  type="button"
                  onClick={forceSignOut}
                  style={{
                    background: '#fff', color: '#1E3A8A', border: '1px solid #BFDBFE',
                    padding: '10px 16px', borderRadius: '9px', fontSize: '12.5px',
                    fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit',
                  }}
                >
                  Ondoka, ningie kwa akaunti nyingine
                </button>
              </div>
            </div>
          )}
          <button
            type="submit"
            style={styles.btn}
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'Sign In →'}
          </button>
        </form>

        {/* FORGOT PASSWORD */}
        <div
          style={styles.forgotLink}
          onClick={() => {
            setShowReset(!showReset);
            setResetSent(false);
            setError('');
          }}
        >
          Forgot password?
        </div>

        {showReset && (
          <div style={styles.resetBox}>
            {resetSent ? (
              <div style={styles.resetSuccess}>
                Password reset email sent! Check your inbox.
              </div>
            ) : (
              <form onSubmit={handleReset}>
                <div style={styles.label}>
                  Enter your email to reset password
                </div>
                <input
                  style={styles.input}
                  type="email"
                  placeholder="your@email.com"
                  value={resetEmail}
                  onChange={e => setResetEmail(e.target.value)}
                  required
                />
                <button
                  type="submit"
                  style={styles.resetBtn}
                >
                  Send Reset Link →
                </button>
              </form>
            )}
          </div>
        )}

        {/* BACK TO PUBLIC SITE */}
        <div style={styles.signupLink}>
          <span
            style={styles.signupLinkSpan}
            onClick={() => navigate('/')}
          >
            ← Back to Iyanna Foundation
          </span>
        </div>

        {/* Alama ya toleo — kwa kuthibitisha kwamba deploy imefika */}
        <div style={{
          textAlign: 'center', marginTop: '14px',
          fontSize: '11px', color: 'rgba(0,0,0,0.35)', letterSpacing: '0.5px',
        }}>
          {APP_VERSION}
        </div>

      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(160deg, #041F14 0%, #07271A 40%, #14452F 70%, #041F14 100%)',
    padding: '40px 20px',
    position: 'relative',
    overflow: 'hidden',
  },
  orb: {
    position: 'absolute',
    width: '400px',
    height: '400px',
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(245,124,0,0.12), transparent 70%)',
    top: '-100px',
    right: '-100px',
  },
  card: {
    background: 'rgba(255,255,255,0.06)',
    backdropFilter: 'blur(24px)',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: '24px',
    padding: '44px 40px',
    width: '100%',
    maxWidth: '420px',
    position: 'relative',
    zIndex: 1,
    boxShadow: '0 24px 60px rgba(0,0,0,0.3)',
  },
  logoRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
    marginBottom: '30px',
  },
  logoMark: {
    width: '65px',
    height: '65px',
    borderRadius: '50%',
    overflow: 'hidden',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#041F14',
    padding: '0px',
    boxShadow: '0 4px 16px rgba(0,0,0,0.4)',
    border: '2px solid rgba(255,255,255,0.15)',
  },
  logoName: {
    fontFamily: "'Fraunces', Georgia, serif",
    fontSize: '19px',
    color: '#fff',
    lineHeight: 1.2,
    fontWeight: '700',
  },
  logoSub: {
    fontSize: '10px',
    color: 'rgba(255,255,255,0.4)',
    letterSpacing: '1px',
    marginTop: '2px',
  },
  heading: {
    fontFamily: "'Fraunces', Georgia, serif",
    fontSize: '27px',
    color: '#fff',
    marginBottom: '5px',
  },
  sub: {
    fontSize: '13px',
    color: 'rgba(255,255,255,0.45)',
    marginBottom: '28px',
  },
  pillRow: {
    display: 'flex',
    gap: '8px',
    marginBottom: '26px',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  pill: {
    flex: 1,
    padding: '10px 6px',
    borderRadius: '10px',
    border: '1.5px solid rgba(255,255,255,0.12)',
    background: 'transparent',
    color: 'rgba(255,255,255,0.55)',
    fontSize: '12px',
    cursor: 'pointer',
    fontFamily: 'inherit',
    transition: 'all 0.2s',
    minWidth: '70px',
  },
  pillActive: {
    background: 'rgba(245,124,0,0.18)',
    borderColor: '#F57C00',
    color: '#FFA726',
  },
  hiddenBtn: {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    border: '1.5px solid rgba(255,255,255,0.15)',
    background: 'rgba(255,255,255,0.05)',
    color: 'rgba(255,255,255,0.4)',
    fontSize: '16px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'inherit',
    flexShrink: 0,
    transition: 'all 0.2s',
  },
  label: {
    fontSize: '11px',
    color: 'rgba(255,255,255,0.4)',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    marginBottom: '7px',
  },
  input: {
    width: '100%',
    background: 'rgba(255,255,255,0.07)',
    border: '1.5px solid rgba(255,255,255,0.1)',
    borderRadius: '10px',
    padding: '13px 16px',
    color: '#fff',
    fontSize: '14px',
    marginBottom: '16px',
    outline: 'none',
    fontFamily: 'inherit',
    boxSizing: 'border-box',
  },
  passwordRow: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
    width: '100%',
  },
  passwordInput: {
    width: '100%',
    background: 'rgba(255,255,255,0.07)',
    border: '1.5px solid rgba(255,255,255,0.1)',
    borderRadius: '10px',
    padding: '13px 48px 13px 16px',
    color: '#fff',
    fontSize: '14px',
    outline: 'none',
    fontFamily: 'inherit',
    boxSizing: 'border-box',
  },
  eyeBtn: {
    position: 'absolute',
    right: '14px',
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: 1,
  },
  error: {
    background: 'rgba(211,47,47,0.2)',
    border: '1px solid rgba(211,47,47,0.4)',
    color: '#ff8a80',
    padding: '10px 14px',
    borderRadius: '8px',
    fontSize: '13px',
    marginBottom: '14px',
  },
  btn: {
    width: '100%',
    padding: '14px',
    background: 'linear-gradient(135deg, #F57C00, #FFA726)',
    border: 'none',
    borderRadius: '12px',
    color: '#fff',
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer',
    boxShadow: '0 8px 22px rgba(245,124,0,0.3)',
    fontFamily: 'inherit',
  },
  forgotLink: {
    textAlign: 'center',
    color: 'rgba(255,255,255,0.45)',
    fontSize: '13px',
    marginTop: '16px',
    cursor: 'pointer',
  },
  resetBox: {
    marginTop: '16px',
    background: 'rgba(255,255,255,0.06)',
    borderRadius: '12px',
    padding: '16px',
    border: '1px solid rgba(255,255,255,0.1)',
  },
  resetSuccess: {
    color: '#BBD8C4',
    fontSize: '13px',
    textAlign: 'center',
    padding: '8px 0',
  },
  resetBtn: {
    width: '100%',
    padding: '12px',
    background: 'rgba(255,255,255,0.1)',
    border: '1px solid rgba(255,255,255,0.2)',
    borderRadius: '10px',
    color: '#fff',
    fontFamily: 'inherit',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    marginTop: '8px',
  },
  signupLink: {
    textAlign: 'center',
    color: 'rgba(255,255,255,0.4)',
    fontSize: '13px',
    marginTop: '16px',
  },
  signupLinkSpan: {
    color: '#FFA726',
    cursor: 'pointer',
    fontWeight: '600',
  },
};